import { useState } from 'react';
import { Button, Flex, Heading } from '@chakra-ui/react';
import { RiAddFill } from 'react-icons/ri';

import useGetBoard from './useGetBoard';
import Board from './components/Board';
import NewExecutionDialog from './components/NewExecutionDialog';

const MyAttendances = () => {
  const { stages, interactions, loading } = useGetBoard();
  const [showNewExecutionDialog, setShowNewExecutionDialog] = useState(false);

  return (
    <Flex direction="column" w="100%" minW={0} maxW="100%" gap={6}>
      <Flex alignItems="center" justifyContent="space-between" gap={2}>
        <Heading>
          Meus Atendimentos
        </Heading>

        <Button size="sm" flexShrink={0} onClick={() => setShowNewExecutionDialog(true)}>
          <RiAddFill /> Novo atendimento avulso
        </Button>
      </Flex>

      <Board stages={stages} interactions={interactions} loading={loading} />

      {showNewExecutionDialog && (
        <NewExecutionDialog handleClose={() => setShowNewExecutionDialog(false)} />
      )}
    </Flex>
  );
};

export default MyAttendances;
